document.addEventListener("DOMContentLoaded", () => {

const stickyATC = document.getElementById("StickyAddToCart");
const stickyATCText = document.getElementById("StickyAddToCartText");
const stickyBuy = document.getElementById("StickyBuyNow");
const stickyPrice = document.getElementById("StickyPrice");
const stickyBISTrigger = document.getElementById("StickyBISTrigger");
const stickyButtonsWrapper = document.getElementById("StickyCartButtons");

function setButtonLoading(button, isLoading) {
  if (!button) return;
  button.classList.toggle('loading', isLoading);
  button.toggleAttribute('aria-disabled', isLoading);
  button.querySelector('.loading__spinner')?.classList.toggle('hidden', !isLoading);
}

const productForm = document.querySelector("product-form form");

if (!productForm) return;

function getVariantId() {
  return productForm.querySelector('[name="id"]')?.value;
}

function getQuantity() {
  return productForm.querySelector('[name="quantity"]')?.value || 1;
}

function formatMoney(cents) {
  const format = window.shopifyMoneyFormat || '₹{{amount}}';
  const placeholder = format.match(/\{\{\s*(\w+)\s*\}\}/);
  const key = placeholder ? placeholder[1] : 'amount';
  const precision = key.indexOf('no_decimals') === -1 ? 2 : 0;
  const thousands = key.indexOf('comma_separator') === -1 ? ',' : '.';
  const decimal = key.indexOf('comma_separator') === -1 ? '.' : ',';

  const parts = (cents / 100).toFixed(precision).split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
  const value = parts.length > 1 ? parts.join(decimal) : parts[0];

  return placeholder ? format.replace(placeholder[0], value) : format + value;
}

function addToCart() {
  if (stickyATC?.getAttribute('aria-disabled') === 'true') return;

  // Delegate to the real product form so the cart drawer and error handling
  // behave exactly like the main Add to Cart button.
  setButtonLoading(stickyATC, true);

  if (typeof productForm.requestSubmit === 'function') {
    productForm.requestSubmit();
  } else {
    productForm.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
  }
}

let isBuyingNow = false;

async function buyNow() {
  if (isBuyingNow) return;
  if (stickyBuy?.getAttribute('aria-disabled') === 'true') return;

  const id = getVariantId();
  if (!id) return;

  isBuyingNow = true;
  setButtonLoading(stickyBuy, true);

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: id,
        quantity: getQuantity()
      })
    });

    if (response.ok) {
      window.location = '/checkout';
      return;
    }

    const data = await response.json();
    const errorWrapper = document.querySelector('.product-form__error-message-wrapper');
    const errorMessage = errorWrapper?.querySelector('.product-form__error-message');
    if (errorWrapper && errorMessage) {
      errorMessage.textContent = data.description || data.message || 'Unable to add product to cart';
      errorWrapper.removeAttribute('hidden');
    }
  } finally {
    isBuyingNow = false;
    setButtonLoading(stickyBuy, false);
  }
}

stickyATC?.addEventListener('click', addToCart);
stickyBuy?.addEventListener('click', buyNow);

if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  // Block Add to Cart / Buy Now for the moment between picking a new
  // variant and product-info.js's fetch resolving - until then the hidden
  // `id` input still holds the *previous* variant, so a fast tap here would
  // add the wrong one. aria-disabled (not the `disabled` attribute or
  // .cst-sold-out) so it only blocks clicks and greys out via the existing
  // `.button[aria-disabled='true']` rule, without hiding/reflowing anything
  // the way the real sold-out state does.
  subscribe(PUB_SUB_EVENTS.variantChangePending, (event) => {
    try {
      const { sectionId, pending, isQuickAdd } = event?.data || {};
      // Quick View re-fetches the real product page, so its <product-info>
      // ends up with the SAME sectionId as the actual PDP (both come from
      // the same static template section key) - the sectionId check below
      // can't tell them apart on its own, so isQuickAdd is the hard filter.
      if (isQuickAdd) return;
      const mainProductSection = productForm.closest('section[id^="shopify-section-"]');
      if (mainProductSection && sectionId && mainProductSection.id !== `shopify-section-${sectionId}`) {
        return;
      }

      [stickyATC, stickyBuy].forEach((button) => {
        if (!button) return;
        // Explicit setAttribute/removeAttribute rather than toggleAttribute:
        // the latter sets an empty-string value, which matches neither the
        // `.button[aria-disabled='true']` CSS rule nor the `=== 'true'`
        // checks in addToCart()/buyNow() and product-form.js.
        if (pending) {
          button.setAttribute('aria-disabled', 'true');
        } else {
          button.removeAttribute('aria-disabled');
        }
      });
    } catch (error) {
      console.error('sticky-mobile-cart: failed to handle variant change pending state', error);
    }
  });

  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    try {
      if (event?.source !== 'product-form') return;
      setButtonLoading(stickyATC, false);
    } catch (error) {
      console.error('sticky-mobile-cart: failed to handle cart update', error);
    }
  });

  subscribe(PUB_SUB_EVENTS.cartError, (event) => {
    try {
      if (event?.source !== 'product-form') return;
      setButtonLoading(stickyATC, false);
    } catch (error) {
      console.error('sticky-mobile-cart: failed to handle cart error', error);
    }
  });

  // subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
  //   try {
  //     const { html, sectionId, variant } = event?.data || {};
  //     if (!variant) return;

  //     // Mirror the real submit button's disabled state rather than the raw
  //     // variant.available flag, since that button also accounts for quantity
  //     // rules and other purchasability checks the flag alone doesn't cover.
  //     const realSubmitButton = html?.getElementById(`ProductSubmitButton-${sectionId}`);
  //     const isAvailable = realSubmitButton ? !realSubmitButton.hasAttribute('disabled') : !!variant.available;

  //     if (stickyPrice) {
  //       // Match Shopify's own `money` filter output (a quoted `.money` span) so
  //       // third-party scripts that scan for already-formatted prices don't
  //       // re-wrap our plain text and mangle it.
  //       stickyPrice.innerHTML = '<span class="money">' + formatMoney(variant.price) + '</span>';
  //     }

  //     // Inline style.display is set directly on the button (not left to the
  //     // .cst-sold-out CSS class alone) so hiding Add to cart for a sold-out
  //     // variant doesn't depend on sticky-mobile-cart.css - it's loaded async
  //     // and may not have applied yet, which is what let a "Sold Out" button
  //     // flash alongside Notify Me. An inline style always wins the cascade
  //     // immediately, regardless of any stylesheet's load order or
  //     // specificity (unlike a plain `hidden` attribute, which base.css's
  //     // `.button { display: inline-flex }` would override).
  //     if (stickyATC) {
  //       stickyATC.disabled = !isAvailable;
  //       stickyATC.style.display = isAvailable ? '' : 'none';
  //       if (stickyATCText) stickyATCText.textContent = isAvailable ? 'Add to cart' : 'Sold Out';
  //     }

  //     // Buy Now stays visible when sold out - only disabled - so it keeps
  //     // sitting next to Notify Me instead of leaving it alone to stretch
  //     // full width.
  //     if (stickyBuy) {
  //       stickyBuy.disabled = !isAvailable;
  //     }

  //     // Kept in sync for any styling still hooked off the wrapper class, but
  //     // it's no longer what makes the buttons disappear - the inline
  //     // style.display above is.
  //     if (stickyButtonsWrapper) {
  //       stickyButtonsWrapper.classList.toggle('cst-sold-out', !isAvailable);
  //     }

  //     // Mirrors product-info.js's updateSourceFromDestination('BISTrigger'):
  //     // copy the fetched section's Notify Me trigger (rendered server-side
  //     // only when actually sold out) into the sticky cart's own container.
  //     if (stickyBISTrigger && html) {
  //       const sourceTrigger = html.getElementById(`BISTrigger-${sectionId}`);
  //       stickyBISTrigger.innerHTML = sourceTrigger ? sourceTrigger.innerHTML : '';
  //     }
  //   } catch (error) {
  //     console.error('sticky-mobile-cart: failed to sync variant change', error);
  //   }
  // });
  subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
  try {
    const { html, sectionId, variant, isQuickAdd } = event?.data || {};
    if (!variant) return;

    // IMPORTANT:
    // Sticky cart should react ONLY to the main PDP product variant change.
    // Ignore variant changes from "You may also like this",
    // recommendations, quick-add, etc. isQuickAdd is the hard filter since
    // sectionId alone can collide between the real PDP and a Quick View
    // modal for a different product (see isQuickAdd getter in
    // product-info.js for why).
    if (isQuickAdd) return;

    const mainProductSection = productForm.closest(
      'section[id^="shopify-section-"]'
    );

    if (
      mainProductSection &&
      sectionId &&
      mainProductSection.id !== `shopify-section-${sectionId}`
    ) {
      return;
    }

    const realSubmitButton = html?.getElementById(
      `ProductSubmitButton-${sectionId}`
    );

    const isAvailable = realSubmitButton
      ? !realSubmitButton.hasAttribute('disabled')
      : !!variant.available;

    if (stickyPrice) {
      stickyPrice.innerHTML =
        '<span class="money">' + formatMoney(variant.price) + '</span>';
    }

    if (stickyATC) {
      stickyATC.disabled = !isAvailable;
      stickyATC.style.display = isAvailable ? '' : 'none';

      if (stickyATCText) {
        stickyATCText.textContent = isAvailable
          ? 'Add to cart'
          : 'Sold Out';
      }
    }

    if (stickyBuy) {
      stickyBuy.disabled = !isAvailable;
    }

    if (stickyButtonsWrapper) {
      stickyButtonsWrapper.classList.toggle(
        'cst-sold-out',
        !isAvailable
      );
    }

    if (stickyBISTrigger && html) {
      const sourceTrigger = html.getElementById(
        `BISTrigger-${sectionId}`
      );

      stickyBISTrigger.innerHTML = sourceTrigger
        ? sourceTrigger.innerHTML
        : '';
    }
  } catch (error) {
    console.error(
      'sticky-mobile-cart: failed to sync variant change',
      error
    );
  }
});
}

});
